"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompoundLens__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "AddReservesMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "AddReservesOverflow",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowAndDepositBackFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowCapReached",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowCashNotAvailable",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowPaused",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "usdThreshold",
                type: "uint256",
            },
        ],
        name: "BorrowValueMustBeLargerThanThreshold",
        type: "error",
    },
    {
        inputs: [],
        name: "CantEnterPausedMarket",
        type: "error",
    },
    {
        inputs: [],
        name: "CantExitMarketWithNonZeroBorrowBalance",
        type: "error",
    },
    {
        inputs: [],
        name: "CantSweepUnderlying",
        type: "error",
    },
    {
        inputs: [],
        name: "ComptrollerMismatch",
        type: "error",
    },
    {
        inputs: [],
        name: "EitherAssetOrDebtMustBeZero",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "groupId",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "cDepositVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "suDepositVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "cBorrowVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "suBorrowVal",
                type: "uint256",
            },
        ],
        name: "EitherAssetOrDebtMustBeZeroInGroup",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpiredSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientCollateral",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientShortfall",
        type: "error",
    },
    {
        inputs: [],
        name: "InterMintNotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidBlockNumber",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidCloseFactor",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidComptroller",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidDiscountRate",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidExchangeRate",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidGroupId",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInput",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInterestRateModel",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidMinSuBorrowValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidRedeem",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidReduceAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidReserveFactor",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignatureForRedeemFaceValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignatureLength",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSuToken",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidTimestamp",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_LiquidatorIsBorrower",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_RepayAmountIsMax",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_RepayAmountIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_SeizeTooMuch",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateCollateralMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketAlreadyListed",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketAlreadyUnlisted",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketCanOnlyInitializeOnce",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketNotEmpty",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "MinDelayNotReached",
        type: "error",
    },
    {
        inputs: [],
        name: "MintMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "MintPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "MintTokensCantBeZero",
        type: "error",
    },
    {
        inputs: [],
        name: "NoRedemptionProvider",
        type: "error",
    },
    {
        inputs: [],
        name: "NotCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughForSeize",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughRedeemAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughRedeemTokens",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughUnderlyingAfterRedeem",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughUnderlyingForMint",
        type: "error",
    },
    {
        inputs: [],
        name: "NotLiquidatableYet",
        type: "error",
    },
    {
        inputs: [],
        name: "NotSuToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyAdmin",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyAdminOrPauser",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyListedCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyPausedMarketCanBeUnlisted",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyPendingAdmin",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyRedemptionManager",
        type: "error",
    },
    {
        inputs: [],
        name: "OverThreshold",
        type: "error",
    },
    {
        inputs: [],
        name: "PriceError",
        type: "error",
    },
    {
        inputs: [],
        name: "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        type: "error",
    },
    {
        inputs: [],
        name: "RedeemMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "RedeemTransferOutNotPossible",
        type: "error",
    },
    {
        inputs: [],
        name: "RedemptionSeizeTooMuch",
        type: "error",
    },
    {
        inputs: [],
        name: "RedemptionSignerNotInitialized",
        type: "error",
    },
    {
        inputs: [],
        name: "ReduceReservesCashNotAvailable",
        type: "error",
    },
    {
        inputs: [],
        name: "ReduceReservesMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "Reentered",
        type: "error",
    },
    {
        inputs: [],
        name: "RepayBorrowMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "RepayTokenNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "SeizePaused",
        type: "error",
    },
    {
        inputs: [],
        name: "SeizeTokenNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "Seize_LiquidatorIsBorrower",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderMustBeCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "SetInterestRateModelMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "SetReservesFactorMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "SupplyCapReached",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenInOrAmountInMustBeZero",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenTransferInFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenTransferOutFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "TooMuchRepay",
        type: "error",
    },
    {
        inputs: [],
        name: "TotalBorrowsNotZero",
        type: "error",
    },
    {
        inputs: [],
        name: "TotalSupplyNotZero",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferNotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "UnderlyingBalanceError",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAddressNotAllowed",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract ICToken",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "account",
                type: "address",
            },
        ],
        name: "cTokenBalances",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "cToken",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "isCToken",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "isCEther",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "balanceOf",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "borrowBalanceCurrent",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "balanceOfUnderlying",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenBalance",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenAllowance",
                        type: "uint256",
                    },
                ],
                internalType: "struct CompoundLens.CTokenBalances",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ICToken[]",
                name: "cTokens",
                type: "address[]",
            },
            {
                internalType: "address payable",
                name: "account",
                type: "address",
            },
        ],
        name: "cTokenBalancesAll",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "cToken",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "isCToken",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "isCEther",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "balanceOf",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "borrowBalanceCurrent",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "balanceOfUnderlying",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenBalance",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenAllowance",
                        type: "uint256",
                    },
                ],
                internalType: "struct CompoundLens.CTokenBalances[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ICToken",
                name: "cToken",
                type: "address",
            },
        ],
        name: "cTokenMetadata",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "cToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "exchangeRateCurrent",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "supplyRatePerBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "borrowRatePerBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "reserveFactorMantissa",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalBorrows",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalReserves",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalSupply",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalCash",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "isListed",
                        type: "bool",
                    },
                    {
                        internalType: "address",
                        name: "underlyingAssetAddress",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "cTokenDecimals",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "underlyingDecimals",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "isCToken",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "isCEther",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "borrowCap",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "depositCap",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "heteroLiquidationIncentive",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "homoLiquidationIncentive",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "sutokenLiquidationIncentive",
                        type: "uint256",
                    },
                    {
                        internalType: "uint8",
                        name: "groupId",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "intraRate",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "mintRate",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "interRate",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "discountRate",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "interMintAllowed",
                        type: "bool",
                    },
                ],
                internalType: "struct CompoundLens.CTokenMetadata",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ICToken[]",
                name: "cTokens",
                type: "address[]",
            },
        ],
        name: "cTokenMetadataAll",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "cToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "exchangeRateCurrent",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "supplyRatePerBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "borrowRatePerBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "reserveFactorMantissa",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalBorrows",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalReserves",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalSupply",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalCash",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "isListed",
                        type: "bool",
                    },
                    {
                        internalType: "address",
                        name: "underlyingAssetAddress",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "cTokenDecimals",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "underlyingDecimals",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "isCToken",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "isCEther",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "borrowCap",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "depositCap",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "heteroLiquidationIncentive",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "homoLiquidationIncentive",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "sutokenLiquidationIncentive",
                        type: "uint256",
                    },
                    {
                        internalType: "uint8",
                        name: "groupId",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "intraRate",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "mintRate",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "interRate",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "discountRate",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "interMintAllowed",
                        type: "bool",
                    },
                ],
                internalType: "struct CompoundLens.CTokenMetadata[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ICToken",
                name: "cToken",
                type: "address",
            },
        ],
        name: "cTokenUnderlyingPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "cToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "underlyingPrice",
                        type: "uint256",
                    },
                ],
                internalType: "struct CompoundLens.CTokenUnderlyingPrice",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ICToken[]",
                name: "cTokens",
                type: "address[]",
            },
        ],
        name: "cTokenUnderlyingPriceAll",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "cToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "underlyingPrice",
                        type: "uint256",
                    },
                ],
                internalType: "struct CompoundLens.CTokenUnderlyingPrice[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "cTokenCollateral",
                type: "address",
            },
            {
                internalType: "address",
                name: "suToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "suBorrowAmount",
                type: "uint256",
            },
        ],
        name: "calcBorrowAmountForProtectedMint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IComptroller",
                name: "comptroller",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getAccountLimits",
        outputs: [
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "markets",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256",
                        name: "liquidity",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "shortfall",
                        type: "uint256",
                    },
                ],
                internalType: "struct CompoundLens.AccountLimits",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IComptroller",
                name: "comptroller",
                type: "address",
            },
            {
                internalType: "address",
                name: "collateralToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "liabilityToken",
                type: "address",
            },
        ],
        name: "getCollateralRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ICToken",
                name: "comp",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getCompBalanceMetadata",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "balance",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "votes",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "delegate",
                        type: "address",
                    },
                ],
                internalType: "struct CompoundLens.CompBalanceMetadata",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ICToken",
                name: "comp",
                type: "address",
            },
            {
                internalType: "contract IComptroller",
                name: "comptroller",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getCompBalanceMetadataExt",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "balance",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "votes",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "delegate",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "allocated",
                        type: "uint256",
                    },
                ],
                internalType: "struct CompoundLens.CompBalanceMetadataExt",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ICToken",
                name: "comp",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint32[]",
                name: "blockNumbers",
                type: "uint32[]",
            },
        ],
        name: "getCompVotes",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "blockNumber",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "votes",
                        type: "uint256",
                    },
                ],
                internalType: "struct CompoundLens.CompVotes[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IGovernorBravo",
                name: "governor",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "proposalIds",
                type: "uint256[]",
            },
        ],
        name: "getGovBravoProposals",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "proposalId",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "proposer",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "eta",
                        type: "uint256",
                    },
                    {
                        internalType: "address[]",
                        name: "targets",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "values",
                        type: "uint256[]",
                    },
                    {
                        internalType: "string[]",
                        name: "signatures",
                        type: "string[]",
                    },
                    {
                        internalType: "bytes[]",
                        name: "calldatas",
                        type: "bytes[]",
                    },
                    {
                        internalType: "uint256",
                        name: "startBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "forVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "againstVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "abstainVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "canceled",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "executed",
                        type: "bool",
                    },
                ],
                internalType: "struct CompoundLens.GovBravoProposal[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IGovernorBravo",
                name: "governor",
                type: "address",
            },
            {
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "proposalIds",
                type: "uint256[]",
            },
        ],
        name: "getGovBravoReceipts",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "proposalId",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "hasVoted",
                        type: "bool",
                    },
                    {
                        internalType: "uint8",
                        name: "support",
                        type: "uint8",
                    },
                    {
                        internalType: "uint96",
                        name: "votes",
                        type: "uint96",
                    },
                ],
                internalType: "struct CompoundLens.GovBravoReceipt[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IGovernorAlpha",
                name: "governor",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "proposalIds",
                type: "uint256[]",
            },
        ],
        name: "getGovProposals",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "proposalId",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "proposer",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "eta",
                        type: "uint256",
                    },
                    {
                        internalType: "address[]",
                        name: "targets",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "values",
                        type: "uint256[]",
                    },
                    {
                        internalType: "string[]",
                        name: "signatures",
                        type: "string[]",
                    },
                    {
                        internalType: "bytes[]",
                        name: "calldatas",
                        type: "bytes[]",
                    },
                    {
                        internalType: "uint256",
                        name: "startBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "forVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "againstVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "canceled",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "executed",
                        type: "bool",
                    },
                ],
                internalType: "struct CompoundLens.GovProposal[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IGovernorAlpha",
                name: "governor",
                type: "address",
            },
            {
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "proposalIds",
                type: "uint256[]",
            },
        ],
        name: "getGovReceipts",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "proposalId",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "hasVoted",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "support",
                        type: "bool",
                    },
                    {
                        internalType: "uint96",
                        name: "votes",
                        type: "uint96",
                    },
                ],
                internalType: "struct CompoundLens.GovReceipt[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "percentScale",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "enum Version",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class CompoundLens__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.CompoundLens__factory = CompoundLens__factory;
CompoundLens__factory.bytecode = _bytecode;
CompoundLens__factory.abi = _abi;
//# sourceMappingURL=CompoundLens__factory.js.map